import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Route, Switch } from 'react-router-dom';

import { Header, Footer, Navigation } from '../partials';
import { ReportCategory, Report } from '../reports';
import { Profile } from '../profile';
import './layouts.css';

class AuthedLayout extends React.Component {  
    render(){
        return (
            <div className="layout authed-layout">
                <Header />
                <Navigation reportCategories={this.props.reportCategories} user={this.props.user} />
                <div className="main-content">
                    <Switch>
                        <Route path="/profile" exact render={()=><Profile user={this.props.user} />} />
                        <Route 
                            path="/category/:categoryId/report/:reportId"
                            render={ ( ) => <Report user={this.props.user} /> }     
                        />
                        <Route 
                            path="/category/:categoryId" 
                            render={ () => <ReportCategory user={this.props.user} /> } 
                        />
                        
                        <Route path="/" render={()=><ReportCategory user={this.props.user} />} />
                    </Switch>
                </div>
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        reportCategories: state.reportCategories
    };
}

export default withRouter(connect(mapStateToProps)(AuthedLayout));


// WEBPACK FOOTER //
// ./src/components/layouts/AuthedLayout.jsx